import {AdvertisingPlatformCodeEnum} from '@dms/api/shared';

import {PlatformPhotoSettings} from './PlatformPhotoSettings';

export function PlatformSettingsAudiPl() {
  return <PlatformPhotoSettings platformCode={AdvertisingPlatformCodeEnum.AUDI_PL} />;
}
